var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEntertainment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Movies-Immersive--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Movies Immersive Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.356 0.982a0.75 0.75 0 0 0 -1.085 0.67v17.01a0.75 0.75 0 0 0 1.085 0.67c1.008 -0.504 2.9 -1.169 5.625 -1.568a8.153 8.153 0 0 1 2.36 -1.28 4.365 4.365 0 1 1 5.318 0c0.86 0.296 1.657 0.731 2.36 1.28 2.725 0.4 4.617 1.064 5.625 1.568a0.75 0.75 0 0 0 1.086 -0.67V1.651a0.75 0.75 0 0 0 -1.086 -0.67c-1.541 0.77 -5.15 1.917 -10.644 1.917C6.505 2.9 2.898 1.753 1.356 0.982Zm13.509 12.04a2.865 2.865 0 1 1 -5.73 0 2.865 2.865 0 0 1 5.73 0ZM12 17.542a6.676 6.676 0 0 0 -6.28 4.412c-0.21 0.583 0.264 1.143 0.883 1.143h10.795c0.618 0 1.093 -0.56 0.883 -1.143a6.676 6.676 0 0 0 -6.28 -4.413Z",
    clipRule: "evenodd",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEntertainment);
export default ForwardRef;